import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PetService } from '../../../services/pet.service';

declare var $: any;

@Component({
  selector: 'ngx-work-notes-home',
  templateUrl: './notes-home.component.html',
})
export class NotesHomeComponent implements OnInit {

  private _pet_no: number;

  @Input() set pet_no(value: number) {
    this._pet_no = value;
   }

  get pet_no(): number {
    return this._pet_no;
  }

  private _client_no: number;
  
  @Input() set client_no(value: number) {
    this._client_no = value;
  }

  get client_no(): number {
    return this._client_no;
  }

  constructor(
    public petService: PetService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    // this.petService.changePet
    //   .subscribe(message => {
    //     if (message !== this.pet_no) {
    //       this.pet_no = message;
    //       this.petService.getNotesByPetId(this.pet_no).then(() => { });
    //     }
    //   });
  }

  add() {
    $('#modalNewPetNote').modal('toggle')
  }

  edit(item) {
    this.petService.pet_note = item;
    $('#modalNewPetNote').modal('toggle')
  }
}
